import { FileTypes } from "../../../enums/FileUploadEnums";
import { jobStatus } from "../CreateJobView/constants";
import pdfIcon from "../../../assets/images/pdf-icon-red.svg";
import jpgIcon from "../../../assets/images/jpeg-image-icon.svg";
import pngIcon from "../../../assets/images/png-image-icon.svg";
import excelIcon from "../../../assets/images/excel-file-icon.svg";
import csvIcon from "../../../assets/images/csvIcon.svg";
import docIcon from "../../../assets/images/docIcon.svg";

const STEP_5 = [
  jobStatus.l1ApprovalPending,
  jobStatus.l1Approved,
  jobStatus.l1rejected,
  jobStatus.l2approvalPending,
  jobStatus.l2Approved,
  jobStatus.l2rejected,
  jobStatus.internalApprovalComplete,
  jobStatus.dispatchApproved,
];
const STEP_4 = [...STEP_5, jobStatus.quoteApproved, jobStatus.internalApprovalDraft];
const STEP_3 = [...STEP_4, jobStatus.quoteShared];
const STEP_2 = [...STEP_3, jobStatus.buildQuote];
const STEP_1 = [...STEP_2, jobStatus.materialTruckDetails];

export const ViewableStates = {
  STEP_1,
  STEP_2,
  STEP_3,
  STEP_4,
  STEP_5,
};

export const ViewJobMessages = {
  NO_DATA_FOR_SECTION: "No data available for this section",
};

export const NoActionOnSubmissionStates = [
  jobStatus.l1rejected,
  jobStatus.l2rejected,
  jobStatus.l2Approved,
  jobStatus.internalApprovalComplete,
  jobStatus.dispatchApproved,
];

export const ViewJobConstants = {
  CASH_OR_CREDIT_DOCS_TITLE: "Project Documents",
  GENERAL_PROJECT_DOCS_TITLE: "Overall Project Information Sheet",
  NO_DOCUMENTS_TITLE: "No Uploaded Documents",
  PROJECT_INFO_SHEET_TITLE:" Overall Project Info Sheet",
};

export const iconMapping = {
  [FileTypes.PDF]: pdfIcon,
  [FileTypes.CSV]: csvIcon,
  [FileTypes.XLS]: excelIcon,
  [FileTypes.XLSX]: excelIcon,
  [FileTypes.DOC]: docIcon,
  [FileTypes.DOCX]: docIcon,
  [FileTypes.PNG]: pngIcon,
  [FileTypes.JPEG]: jpgIcon,
  [FileTypes.JPG]: jpgIcon,
};
